import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Calendar } from 'primeng/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { catchError, forkJoin, of } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-update-student-enrollment-details',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './update-student-enrollment-details.component.html',
  styleUrl: './update-student-enrollment-details.component.scss'
})
export class UpdateStudentEnrollmentDetailsComponent {


  today: Date = new Date();
  createFieldFormValue: any = {};
  previousStudentData: any = {};
  isSubmitted: boolean = false;
  @Input() studentDetails: any = {};
  @Input() allLeadFeilds: any = [];
  fieldValues: { [key: string]: any } = {};

  @ViewChild('dobPicker') dobPicker!: Calendar;
  @Output() handleUpdateData = new EventEmitter<any>();

  @Input() fullUserList: any = [];
  @Input() fullCourseList: any = [];
  @Input() paymentForList: any = [];
  @Input() users: any = [];
  @Input() userslist: any[] = [];

  isLoading: boolean = false;
  @Input() allCourses: any = [];

  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  genderOptions: any[] = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  prefixOptions: any[] = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr', value: 'Dr' },
    { label: 'Prof', value: 'Prof' }
  ];


  documentStatusList = [
    { label: 'Verified', value: 'verified' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' }
  ];

  enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  modeOfStudyOptions: any[] = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
    { label: 'Hybrid', value: 'Hybrid' }
  ];

  paymentStatusList = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Failed', value: 'Failed' }
  ];

  paymentModeList = [
    { label: 'Cash', value: 'Cash' },
    { label: 'Credit Card', value: 'Credit Card' },
    { label: 'Debit Card', value: 'Debit Card' },
    { label: 'Bank Transfer (NEFT/RTGS/IMPS)', value: 'Bank Transfer' },
    { label: 'Cheque', value: 'Cheque' },
    { label: 'UPI (Google Pay / PhonePe / Paytm)', value: 'UPI' },
    { label: 'Net Banking', value: 'Net Banking' },
    { label: 'Demand Draft', value: 'Demand Draft' },
    { label: 'Wallet', value: 'Wallet' },
    { label: 'Other', value: 'Other' }
  ];


  isFixedColumn: boolean = true;

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private leadActivityService: LeadActivityService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    console.log("studentDetails ", this.studentDetails);
    console.log("all users ", this.users);

    if (changes['studentDetails'] && changes['studentDetails'].currentValue) {
      this.createFieldFormValue = { ...this.studentDetails };
      this.fieldValues = this.studentDetails.dynamic_fields || {};
      
      // Convert date strings to Date objects
      this.createFieldFormValue.date_of_birth = this.studentDetails.date_of_birth
        ? new Date(this.studentDetails.date_of_birth)
        : null;

      // Initialize payment_details if it exists and has payment_date
      if (this.createFieldFormValue.payment_details) {
        this.createFieldFormValue.payment_details = JSON.parse(JSON.stringify(this.studentDetails.payment_details));
        if (this.createFieldFormValue.payment_details.payment_date) {
          this.createFieldFormValue.payment_details.payment_date = new Date(this.createFieldFormValue.payment_details.payment_date);
        }
      } else {
        this.createFieldFormValue.payment_details = {
          amount: null,
          payment_for: '',
          payment_mode: '',
          payment_date: null,
          remarks: ''
        };
      }

      // Store previousStudentData AFTER all conversions
      this.previousStudentData = JSON.parse(JSON.stringify(this.createFieldFormValue));
      // Restore Date object after JSON.stringify
      if (this.createFieldFormValue.date_of_birth) {
        this.previousStudentData.date_of_birth = new Date(this.createFieldFormValue.date_of_birth);
      }
      if (this.createFieldFormValue.payment_details?.payment_date) {
        this.previousStudentData.payment_details.payment_date = new Date(this.createFieldFormValue.payment_details.payment_date);
      }
    }
  }

  ngOnInit() {
    if (this.studentDetails) {
      this.createFieldFormValue = { ...this.studentDetails };

      this.createFieldFormValue.date_of_birth = this.studentDetails.date_of_birth
        ? new Date(this.studentDetails.date_of_birth)
        : null;

      if (this.createFieldFormValue.payment_details) {
        this.createFieldFormValue.payment_details = JSON.parse(JSON.stringify(this.studentDetails.payment_details));
        if (this.createFieldFormValue.payment_details.payment_date) {
          this.createFieldFormValue.payment_details.payment_date = new Date(this.createFieldFormValue.payment_details.payment_date);
        }
      } else {
        this.createFieldFormValue.payment_details = {
          amount: null,
          payment_for: '',
          payment_mode: '',
          payment_date: null,
          remarks: ''
        };
      }

      // Store previousStudentData AFTER all conversions
      this.previousStudentData = JSON.parse(JSON.stringify(this.createFieldFormValue));
      // Restore Date object after JSON.stringify
      if (this.createFieldFormValue.date_of_birth) {
        this.previousStudentData.date_of_birth = new Date(this.createFieldFormValue.date_of_birth);
      }
      if (this.createFieldFormValue.payment_details?.payment_date) {
        this.previousStudentData.payment_details.payment_date = new Date(this.createFieldFormValue.payment_details.payment_date);
      }
    }
  }

  onPaymentForChange(event: any) {
    console.log("Payment For Changed:", event);
    console.log("paymentForList:", this.paymentForList);
    // Set amount based on selected payment_for
    const selectedPayment = this.paymentForList.find((item: any) => item.value === event);
    if (selectedPayment && this.createFieldFormValue.payment_details) {
      this.createFieldFormValue.payment_details.amount = selectedPayment.total_fees || null;
    }
  }

  submitForm(isValid: any) {
    this.isSubmitted = true;

    if (!isValid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
      return;
    }

    console.log("createFieldFormValue: ", this.createFieldFormValue);
    console.log("previousStudentData: ", this.previousStudentData);

    this.isLoading = true;

    // Check if only guardian fields changed
    const guardianFieldsChanged = 
      (this.createFieldFormValue.guardian_name !== this.previousStudentData.guardian_name ||
       this.createFieldFormValue.guardian_contact !== this.previousStudentData.guardian_contact);

    // Check if enrollment-related fields changed
    const enrollmentFieldsChanged = 
      this.createFieldFormValue.enrollment_status !== this.previousStudentData.enrollment_status ||
      this.createFieldFormValue.course_id !== this.previousStudentData.course_id ||
      this.createFieldFormValue.assign_to !== this.previousStudentData.assign_to ||
      this.createFieldFormValue.document_status !== this.previousStudentData.document_status ||
      this.createFieldFormValue.mode_of_study !== this.previousStudentData.mode_of_study ||
      this.createFieldFormValue.payment_status !== this.previousStudentData.payment_status ||
      JSON.stringify(this.createFieldFormValue.payment_details) !== JSON.stringify(this.previousStudentData.payment_details) ||
      this.createFieldFormValue.remarks !== this.previousStudentData.remarks;

    // Check if lead-related fields changed
    const leadFieldsChanged = 
      this.createFieldFormValue.prefix !== this.previousStudentData.prefix ||
      this.createFieldFormValue.first_name !== this.previousStudentData.first_name ||
      this.createFieldFormValue.last_name !== this.previousStudentData.last_name ||
      this.createFieldFormValue.email !== this.previousStudentData.email ||
      this.createFieldFormValue.phone !== this.previousStudentData.phone ||
      this.createFieldFormValue.alternate_phone !== this.previousStudentData.alternate_phone ||
      this.createFieldFormValue.date_of_birth?.getTime() !== this.previousStudentData.date_of_birth?.getTime() ||
      this.createFieldFormValue.age !== this.previousStudentData.age ||
      this.createFieldFormValue.gender !== this.previousStudentData.gender ||
      this.createFieldFormValue.nationality !== this.previousStudentData.nationality ||
      this.createFieldFormValue.address !== this.previousStudentData.address ||
      this.createFieldFormValue.city !== this.previousStudentData.city ||
      this.createFieldFormValue.state !== this.previousStudentData.state ||
      this.createFieldFormValue.country !== this.previousStudentData.country ||
      this.createFieldFormValue.postal_code !== this.previousStudentData.postal_code ||
      this.createFieldFormValue.source !== this.previousStudentData.source ||
      this.createFieldFormValue.preferred_location !== this.previousStudentData.preferred_location ||
      this.createFieldFormValue.interested_course !== this.previousStudentData.interested_course ||
      JSON.stringify(this.createFieldFormValue.dynamic_fields || {}) !== JSON.stringify(this.previousStudentData.dynamic_fields || {});

    const updateCalls: any[] = [];

    // If guardian fields or other enrollment fields changed, call enrollment API
    if (guardianFieldsChanged || enrollmentFieldsChanged) {
      const payload = {
        enrollment_id: [this.createFieldFormValue.enrollment_id],
        organization_id: this.localStorage.getOrganizationId(),
        user_id: this.createFieldFormValue.user_id,
        lead_id: this.createFieldFormValue.lead_id,
        enrollment_status: this.createFieldFormValue.enrollment_status,
        course_id: this.createFieldFormValue.course_id,
        assign_to: this.createFieldFormValue.assign_to,
        document_status: this.createFieldFormValue.document_status,
        mode_of_study: this.createFieldFormValue.mode_of_study,
        payment_status: this.createFieldFormValue.payment_status,
        payment_details: this.createFieldFormValue.payment_details,
        guardian_name: this.createFieldFormValue.guardian_name,
        guardian_contact: this.createFieldFormValue.guardian_contact,
        remarks: this.createFieldFormValue.remarks,
        old_data: {
          ...this.previousStudentData,
          assignedUser: this.fullUserList.find((user: any) => user.user_id === this.previousStudentData.assign_to),
          course: this.fullCourseList.find((course: any) => course.course_id === this.previousStudentData.course_id)
        },
        new_data: {
          ...this.createFieldFormValue,
          assignedUser: this.fullUserList.find((user: any) => user.user_id === this.createFieldFormValue.assign_to),
          course: this.fullCourseList.find((course: any) => course.course_id === this.createFieldFormValue.course_id)
        },
        user: this.users.find((user: any) => user.user_id === this.createFieldFormValue.user_id)
      };

      updateCalls.push(
        this.api.updateEnrollment(payload).pipe(
          catchError(error => {
            console.log('Error updating enrollment:', error);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update enrollment.' });
            return of(null);
          })
        )
      );
    }

    // If lead fields changed, call lead API
    if (leadFieldsChanged) {
      const leadPayload = {
        lead_id: this.createFieldFormValue.lead_id,
        organization_id: this.localStorage.getOrganizationId(),
        user_id: this.createFieldFormValue.user_id,
        prefix: this.createFieldFormValue.prefix,
        first_name: this.createFieldFormValue.first_name,
        last_name: this.createFieldFormValue.last_name,
        email: this.createFieldFormValue.email,
        phone: this.createFieldFormValue.phone,
        alternate_phone: this.createFieldFormValue.alternate_phone,
        date_of_birth: this.createFieldFormValue.date_of_birth,
        age: this.createFieldFormValue.age,
        gender: this.createFieldFormValue.gender,
        nationality: this.createFieldFormValue.nationality,
        address: this.createFieldFormValue.address,
        city: this.createFieldFormValue.city,
        state: this.createFieldFormValue.state,
        country: this.createFieldFormValue.country,
        postal_code: this.createFieldFormValue.postal_code,
        source: this.createFieldFormValue.source,
        preferred_location: this.createFieldFormValue.preferred_location,
        interested_course: this.createFieldFormValue.interested_course,
        dynamic_fields: this.createFieldFormValue.dynamic_fields,
        old_lead_data: this.previousStudentData,
        user: this.users.find((user: any) => user.user_id === this.createFieldFormValue.user_id)
      };

      updateCalls.push(
        this.api.updateLead(leadPayload).pipe(
          catchError(error => {
            console.log('Error updating student details:', error);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update student details.' });
            return of(null);
          })
        )
      );
    }

    // If no changes detected
    if (updateCalls.length === 0) {
      this.isLoading = false;
      this.isSubmitted = false;
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'No changes detected' });
      return;
    }

    forkJoin(updateCalls).subscribe({
      next: (responses) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Student details updated successfully' });
        this.handleUpdateData.emit(this.createFieldFormValue);
        this.previousStudentData = JSON.parse(JSON.stringify(this.createFieldFormValue));
        // Restore Date objects after JSON.stringify
        if (this.createFieldFormValue.date_of_birth) {
          this.previousStudentData.date_of_birth = new Date(this.createFieldFormValue.date_of_birth);
        }
        if (this.createFieldFormValue.payment_details?.payment_date) {
          this.previousStudentData.payment_details.payment_date = new Date(this.createFieldFormValue.payment_details.payment_date);
        }
        this.isSubmitted = false;
      },
      error: (err) => {
        console.log('Unexpected error:', err);
        this.isLoading = false;
        this.isSubmitted = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      }
    });
  }

}
